import CssBaseLine from './CssBaseline';
import Select from './Select';

export default {
  ...CssBaseLine,
  ...Select,
};
